<template>
  <div class="col-md-12">
    <div class="note-disclaimer"> <span class="fa-bg"><i class="fa fa-exclamation"></i></span> If you take a generic medication, list the generic name, not the brand name.
      This helps ensure accurate review of your prescriptions.
    </div>
  </div>
</template>
<script>
export default {
  name: "MedicalNotes"
}
</script>
<style scoped>
.note-disclaimer{
  background-color: #fff;
  border-radius: 6px;
  border: 1px solid #b70218;
  border-left: 4px solid #b70218;
  padding: 14px;
  margin-bottom: 1rem;
  color: #b70218;
  font-size: 14px;
  font-weight: 500;
}
.fa-bg{
  background-color: #eeeeee;
  padding: 0.5rem 0.85rem;
  border-radius: 50px;
  margin-right: 6px;
}
</style>